import { Text } from 'components';
import { formatLocale, theme } from 'lib';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const WithImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin: ${(props) => props.margin && '0'} p {
    font-size: 18px;
    margin-top: 5px;
  }

  @media (max-width: 1024px) {
    ${(props) => props.mobileImageless && 'display: none;'}
  }
`;

const Container = styled.div`
  margin: ${(props) => (props.marg ? props.marg : '0')};
`;

const OpacityContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
`;

const InnerContainer = styled.div`
  padding: 11px 9px;

  h5 {
    font-size: 16px;
    font-weight: 500;
    color: ${theme.SECONDARY};
  }

  h1 {
    font-size: 28px;
    font-weight: 700;
    margin-top: 10px;
    color: #fff;
    height 207px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 1024px) {
    padding: 8px 7px;

    h1 {
      font-size: 24px;
    }
  }
`;

const ImageBackground = styled.div`
  background: url(${(props) => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: ${(props) => (props.large ? '570px' : (props) => (props.big ? '285px' : '260px'))};
  width: ${(props) => (props.large ? '570px' : (props) => (props.big ? '285px' : '260px'))};

  @media (max-width: 1024px) {
    height: ${(props) => (props.large ? '416px' : (props) => (props.big ? '240px' : '200px'))};
    width: ${(props) => (props.large ? '416px' : (props) => (props.big ? '240px' : '200px'))};
  }
`;

const ImagelessContainer = styled.div`
  @media (min-width: 1024px) {
    display: none;
  }

  ${(props) => (!props.mobileImageless ? 'display: none;' : '')}
  width: 100vw;
`;

const ImagelessContent = styled.div`
  @media (max-width: 1024px) {
    border-top: 1px solid;
    margin: 0 17px;
  }
`;

const NewsBox = ({
  item,
  i,
  mobileImageless,
  routeToAdmin,
  large,
  big,
  dontShowDate,
  marg,
  admin
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Container marg={marg}>
      <WithImageWrapper
        className="article-box"
        mobileImageless={mobileImageless}
        // TODO: BEAUTIFY BLOW AND WRITE COMMENT
        onClick={() => {
          navigate(
            `${location.pathname.includes('admin') || admin ? '/admin' : ''}/articles/${item._id}`
          );
        }}
      >
        <ImageBackground
          large={large}
          big={big}
          img={item?.images?.mainMed || require('assets/images/pogba.png')}
        >
          <OpacityContainer>
            <InnerContainer>
              <Text h5>{item.sport.toUpperCase()}</Text>

              <Text h1>{item.title.toUpperCase()}</Text>
            </InnerContainer>
          </OpacityContainer>
        </ImageBackground>

        {!dontShowDate && (
          <Text marg="10px 0 0" size="18px">
            {formatLocale(new Date(item.createdAt), 'dd MMM yyy')}
          </Text>
        )}
      </WithImageWrapper>

      <ImagelessContainer mobileImageless={mobileImageless}>
        <ImagelessContent>
          <Text size="16px" med marg="16px 0 8px" col={theme.SECONDARY}>
            {item.sport}
          </Text>

          <Text size="28px" bold marg="0 0 8px">
            {item.title}
          </Text>

          <Text size="14px" marg="0 0 26px">
            {formatLocale(new Date(item.createdAt), 'dd MMM yyy')}
          </Text>
        </ImagelessContent>
      </ImagelessContainer>
    </Container>
  );
};

export default NewsBox;
